// External Libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import SelectBox from '../../components/ui/SelectBox';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { addStateFunc } from '../../../store/custom-actions/states-actions/AddStateSlicer';
import { getStatesFunc } from '../../../store/custom-actions/states-actions/GetStatesSlicer';
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';

function NewStateForm({ show, onHide }) {
    const { t } = useTranslation();  // Hook to get translation function
    const { register, reset, formState: { errors }, handleSubmit } = useForm();
    const { loading: getCountriesLoading, data: countriesData } = useSelector(state => state.getCountriesSlicer);
    const { loading: submitLoading } = useSelector(state => state.addStateSlicer);
    const [countriesList, setCountriesList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCountriesFunc())
    }, []);

    useEffect(() => {
        countriesData && setCountriesList(countriesData);
    }, [countriesData]);

    const resetForm = () => {
        onHide();
        reset();
    };

    const onSubmit = async (data) => {
        const payload = {
            ...data,
        };

        const result = await dispatch(addStateFunc({ data: payload }));

        if (addStateFunc.fulfilled.match(result)) {
            dispatch(getStatesFunc());
            resetForm();
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('New State')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form
                        id="submit-form-add"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <FormField
                            label="Name"
                            name="name"
                            register={register}
                            required={true}
                            errors={errors}
                        />
                        <FormField
                            label="Shipping"
                            name="shipping_amount"
                            register={register}
                            required={true}
                            errors={errors}
                        />
                        <FormField
                            label="Code"
                            name="code"
                            register={register}
                            required={true}
                            errors={errors}
                        />
                        <div className='mb-3'>
                            <SelectBox
                                label={t("Country")}
                                showLabel={true}
                                name="country_id"
                                register={register}
                                data={countriesList}
                                loading={getCountriesLoading}
                                placeholder={t("Choose Country")}
                                required={true}
                                errors={errors}
                            />
                        </div>
                        <CheckboxField
                            name="active"
                            label="Activity"
                            register={register}
                            errors={errors}
                            defaultChecked={true}
                        />

                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        {t('Close')}
                    </Button>
                    <SubmitButton
                        isLoading={submitLoading}
                        form="submit-form-add"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NewStateForm;
